import React, { useState, useRef, useEffect } from "react";

import logo from '../../icons/photos/chillLogo.png'
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCountryCode } from "../../service/api/countryCode/countryCode";
import { setCountryArray } from "../../feature/countryArray/countryArray";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import OuterHeader from "../../jsx/layouts/outerHeader";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import { lblEnterProblemDescription, txtCategory, txtCreatedOn, txtMessage, txtName, txtPhotos, txtProduct, txtServiceRequestStatus, txtTicketId, txtUpdated } from "../../dataBaseFile/label";
import { getSharedServiceRequest } from "../../service/api/ticket/getSharedServiceRequest";
import './shareableServiceRequest.scss'
import ReadOnlyRating from "../../jsx/components/rating/ReadOnlyRating";
import OuterFooter from "../../jsx/layouts/outerFooter";
import { getPurchaseList } from "../../service/api/ticket/getPurchaseList";
import { urlPattern } from "../../validations/validation";
import { getComposeRecordingsApi } from "../../service/api/video/getComposedRecordings";
import VideoAudioPlayer from "../../component/videoAudioPlayer/videoAudioPlayer";
import { getCallRecordingsApi } from "../../service/api/video/getCallRecordings";

import NewDIYSoloImg from '../../media/images/servicesAssets/NewDIYSoloImg.png';
import NewDIYRemoteProImg from '../../media/images/servicesAssets/NewDIYRemoteProImg.png';
import NewLocalProImg from '../../media/images/servicesAssets/NewLocalProImg.png';

export default function ShareableServiceRequest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const [downloadId, setDownloadId] = useState();

    const [customLoading, setCustomLoading] = useState(false);
    const [receiverData, setReceiverData] = useState([]);
    const [attachmentsArr, setAttachmentsArr] = useState([]);

    const [time, setTime] = useState(0);
    const [updatedTime, setUpdatedTime] = useState(0);

    const [toggleNotesPurchase, setToggleNotesPurchase] = useState(1);

    const [callDetailsObj, setCallDetailsObj] = useState({});
    const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);
    const [showUserRating, setShowUserRating] = useState(0)

    const [timeCallNote, setTimeCallNote] = useState(0);

    const [openDocCall, setOpenDocCall] = React.useState(false);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const handleOpenDocCall = () => {
        setOpenDocCall(true);
    }
    const handleCloseDocCall = () => setOpenDocCall(false);

    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttach, setImageAttach] = useState(1);
    const [proAvailableFlag, setProAvailableFlag] = useState(0)
    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);

    const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});
    const [proDiagnosis, setProDiagnosis] = useState("");
    const [proDiagnosisErr, setProDiagnosisErr] = useState(false);
    const [toggleEditProDiagnosis, setToggleEditProDiagnosis] = useState(false);

    const [proRecommendedSolution, setProRecommendedSolution] = useState(0);
    const [customerSelectedSolution, setCustomerSelectedSolution] = useState(0);


    let pageType = "";

    let serviceId = "";

    if (urlParams.has('serviceRequestId')) {

        serviceId = urlParams.get('serviceRequestId')


    }



    // console.log(serviceId, "serviceId");

    const [isCallList, setIsCallList] = useState([]);

    useEffect(() => {
        if (serviceId) {
            let data = {
                ticket_id_ids: serviceId,
            }

            setCustomLoading(true);

            // dispatch(updateBackDropLoaderWithoutStateTrue());

            dispatch(getSharedServiceRequest(data, (res) => {
                setCustomLoading(false);

                // console.log(res.data, "res");
                setReceiverData(res?.data)
                setAttachmentsArr(res?.data?.attachment_data)
                setTime(res?.data?.created_date_dtm + "000")
                setUpdatedTime(res?.data?.updated_date_dtm + "000")

                setIsCallList(res?.data?.call_list)
                setCallNoteDetailsArr(res?.data?.call_list[0]?.call_notes);
                setCallDetailsObj(res?.data?.call_list[0]?.call_details);
                setTimeCallNote(res?.data?.call_list[0]?.call_details?.created_date_dtm + "000");

                res?.data?.call_list?.map((item, index) => {
                    setCallLogIdsArr(prev => [...prev, item.call_log_id_ids]);
                });

                if (res?.data?.summary_meta_data) {

                    // debugger;
                    // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
                    // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    let finalObject = {};

                    // if(!Object.keys(finalObjectTwo).length > 0) {
                    if (typeof (finalObjectTwo) === 'string') {
                        finalObject = JSON.parse(finalObjectTwo);
                    }


                    console.log(finalObject, "finalObject");
                    console.log(finalObjectTwo, "finalObjectTwo");

                    if (Object.keys(finalObject).length > 0) {
                        setServiceSummaryMetaData(finalObject);
                        setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);
                        setCustomerSelectedSolution(finalObject?.customer_check_info?.customer_selected_solution || 0);
                        setProDiagnosis(finalObject?.pro_check_info?.pro_diagnosis || "");
                    } else if (Object.keys(finalObjectTwo).length > 0) {
                        setServiceSummaryMetaData(finalObjectTwo);
                        setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
                        setCustomerSelectedSolution(finalObjectTwo?.customer_check_info?.customer_selected_solution || 0);
                        setProDiagnosis(finalObjectTwo?.pro_check_info?.pro_diagnosis || "");
                    } else {
                        setServiceSummaryMetaData({});
                    }

                }

            }, (err) => {
                // console.log(err, "err");
                // setCustomLoading(false);

                setResponceMsg(err?.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);

            }))
        }

        if (!serviceId) {
            navigate('/login')
        }
    }, [serviceId])


    const [elements, setElements] = useState([]);
    const rows = elements
    const [page, setPage] = React.useState(1)
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [totalCost, setTotalCost] = useState(0);
    const [pageSize, setPageSize] = useState(25)
    const [totalPage, setTotalPage] = useState(1)
    const [sortByValue, setSortByValue] = useState('DESC')
    const [columnName, setColumnName] = useState("")
    const [searchValue, setSearchValue] = useState('')

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);


    const getCallHistoryDetails = (res) => {
        // console.log(res, "Res")
        setElements(res?.data?.data)
        setTotalNoRecord(res?.data?.total_count)
        setTotalCost(res?.data?.total_estimated_cost)
        if (res?.data.total_count % pageSize === 0) {
            setTotalPage(parseInt(res?.data.total_count / pageSize))
        } else {
            setTotalPage(parseInt(res?.data.total_count / pageSize + 1))
        }
        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    }

    function getCurrentDateTime() {
        const now = new Date();

        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return now.toLocaleString('en-US', options);
    }

    const onLoadData = () => {

        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id') || "");
        data.append("ticket_id_ids", serviceId);
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            getPurchaseList(data, (res) => {
                getCallHistoryDetails(res);
            })
        )

    }

    // Format the price to USD 
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const tooltipCopyTxt = (
        <Tooltip id="tooltip">
            <strong>Copy to clipboard</strong>
        </Tooltip>
    );

    const copyToClipboard = () => {
        setResponceMsg("Link copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    const [firstCheckAPI, setFirstCheckAPI] = useState(true);

    useEffect(() => {
        if (firstCheckAPI) {
            onLoadData();
            setFirstCheckAPI(false)
        }
    }, [toggleNotesPurchase]);

    // Call recordings functions are start here ->>
    const [callLogIdsArr, setCallLogIdsArr] = useState([]);
    const [getCallRecordingsLoading, setGetCallRecordingsLoading] = useState(false);
    const [callRecordingsArr, setCallRecordingsArr] = useState([]);

    const [getComposeRecordingsLoading, setGetComposeRecordingsLoading] = useState(false);
    const [composeRecordingsArr, setComposeRecordingsArr] = useState([]);

    useEffect(() => {
        if (callLogIdsArr?.length > 0) {
            callLogIdsArr?.map((item, index) => {
                console.log(item, "call log ids");
                handleCallRecordingsFn(item)
            })
        }
    }, [callLogIdsArr]);

    const handleCallRecordingsFn = (callLogId) => {
        if (callLogId) {
            setGetCallRecordingsLoading(true);
            setGetComposeRecordingsLoading(true);
            let details = {
                call_log_id: callLogId,
                page_index: 1,
                page_size: 1000,
                sorting_order: 'DESC',
                // sorting_column_name: columnName,
                // search_area: searchValue,
            };

            // dispatch(
            //     getCallRecordingsApi(details, (res) => {
            //         // setElements(res.data.data);
            //         setGetCallRecordingsLoading(false);
            //         //    console.log(res?.data?.data, 'call recordings data')

            //         setCallRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);


            //     }, (err) => {
            //         setGetCallRecordingsLoading(false);
            //     })
            // );

            dispatch(
                getComposeRecordingsApi(details, (res) => {
                    // console.log(res?.data?.data, 'compose recordings data')
                    // setElements(res.data.data);
                    //    console.log(res?.data?.data, 'call recordings data')
                    setGetComposeRecordingsLoading(false);
                    setComposeRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);

                }, (err) => {
                    setGetComposeRecordingsLoading(false);
                })
            );
        }
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        if (minutes === 0) {
            return `${remainingSeconds} seconds`;
        } else if (remainingSeconds === 0) {
            return `${minutes} min`;
        } else {
            return `${minutes} min ${remainingSeconds} seconds`;
        }
    }

    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [videoAudioURL, setVideoAudioURL] = useState('');
    const [openVideoAudio, setOpenVideoAudio] = useState(false);

    const handleOpenVideoAudio = () => {
        setOpenVideoAudio(true);
    }
    const handleCloseVideoAudio = () => {
        setOpenVideoAudio(false);
        setVideoAudioURL('');
    }


    return (

        <>
            <OuterHeader />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: '20px' }}>
                {/* <div className="shareable-service-container" style={{ width: '60%' }}>

                    <p style={{ fontSize: '15px', fontWeight: '600', color: 'black' }}>Service Request Details</p>


                </div> */}

                <div className="shareable-service-container" style={{ width: '60%', marginTop: '10px' }}>
                    <div style={{ fontSize: '15px', fontWeight: '600', color: 'black' }}>
                        <p>Service Request</p>
                    </div>
                    {/* <div onClick={() => { setToggleNotesPurchase(1) }} style={{borderBottom: toggleNotesPurchase === 1 ? '2px solid orange' : 'none', width: "50%", display:'flex', alignItems:'center', cursor:'pointer' }}>
                            <p style={{marginBottom:'0px', paddingLeft:'15px'}}>Call Notes</p>
                        </div>
                        <div onClick={() => { setToggleNotesPurchase(2) }} style={{borderBottom: toggleNotesPurchase === 2 ? '2px solid orange' : 'none', width: "50%", display:'flex',  alignItems:'center', cursor:'pointer' }}>
                            <p style={{marginBottom:'0px', paddingLeft:'15px'}}>Purchase List</p>
                        </div> */}
                    <div className='payment-module-tabs'>
                        <div className='payment-module-individual-tab' onClick={() => setToggleNotesPurchase(1)}>
                            <span
                                className='payment-module-individual-tab-txt'
                                style={{
                                    color: toggleNotesPurchase === 1 ? '#FC8019' : "",
                                    fontWeight: toggleNotesPurchase === 1 ? "700" : "",
                                    fontSize: '14px'
                                }}
                            >Details</span>
                            {toggleNotesPurchase === 1 && <div className='payment-module-active-tab'></div>}
                        </div>
                        <div className='payment-module-individual-tab' onClick={() => setToggleNotesPurchase(2)}>
                            <span
                                className='payment-module-individual-tab-txt'
                                style={{
                                    color: toggleNotesPurchase === 2 ? '#FC8019' : "",
                                    fontWeight: toggleNotesPurchase === 2 ? "700" : "",
                                    fontSize: '14px'
                                }}
                            >Call Notes</span>
                            {toggleNotesPurchase === 2 && <div className='payment-module-active-tab'></div>}
                        </div>

                        <div className='payment-module-individual-tab' onClick={() => setToggleNotesPurchase(3)}>
                            <span
                                className='payment-module-individual-tab-txt'
                                style={{
                                    color: toggleNotesPurchase === 3 ? '#FC8019' : "",
                                    fontWeight: toggleNotesPurchase === 3 ? "700" : "",
                                    fontSize: '14px'
                                }}
                            > Shopping List</span>
                            {toggleNotesPurchase === 3 && <div className='payment-module-active-tab'></div>}
                        </div>
                    </div>
                </div>

                <div className="shareable-service-container" style={{ width: '60%' }}>
                    {toggleNotesPurchase === 1 &&
                        <>
                            <div style={{ margin: '15px' }}>
                                {customLoading ?
                                    <>
                                        <SkeletonDivElement height={'30px'} rows={7} marginBottom={'5px'} />

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '150px', marginRight: '10px' }}>

                                                <SkeletonDivElement height={'170px'} rows={1} marginBottom={'5px'} />
                                            </div>
                                            <div style={{ width: '150px', marginRight: '10px' }}>

                                                <SkeletonDivElement height={'170px'} rows={1} marginBottom={'5px'} />
                                            </div>
                                            <div style={{ width: '150px' }}>
                                                <SkeletonDivElement height={'170px'} rows={1} marginBottom={'5px'} />
                                            </div>
                                        </div>
                                    </> :
                                    <>
                                        <>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtTicketId}</p>
                                                <p className="service-labels-sub"> <strong> #{receiverData?.display_id_int} </strong></p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{"Name"}</p>
                                                <p className="service-labels-sub">{receiverData?.creator_name_chr?.split(' ')[0]}</p>
                                            </div>

                                            {/* <div className='serviceDetailsRows'>
                                <p className="service-labels" >{lblEmail}</p>
                                <p className="service-labels-sub">{receiverData.creator_email_id}</p>
                            </div> */}

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtCategory}</p>
                                                <p className="service-labels-sub">{receiverData?.category_name_chr !== null ? receiverData?.category_name_chr : "NA"}</p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtProduct}</p>
                                                <p className="service-labels-sub">{(receiverData?.product_type_chr !== null || receiverData?.product_type_chr !== '') ? receiverData?.product_type_chr : "NA"}</p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{lblEnterProblemDescription}</p>
                                                <p className="service-labels-sub">{receiverData?.problem_description_chr ? receiverData?.problem_description_chr : "NA"}</p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{"Best Time To Contact"}</p>
                                                <p className="service-labels-sub">{receiverData?.time_slot_name ? receiverData?.time_slot_name : "Not Selected"}</p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{"Best Contact Method"}</p>
                                                <p className="service-labels-sub">{receiverData?.communication_mode_name ? receiverData?.communication_mode_name : "Not Selected"}</p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtCreatedOn}</p>
                                                <p className="service-labels-sub">
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                    }).format(time)}
                                                </p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtUpdated}</p>
                                                <p className="service-labels-sub">
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                    }).format(updatedTime)}
                                                </p>
                                            </div>

                                            <div className='serviceDetailsRows'>
                                                <p className="service-labels" >{txtServiceRequestStatus}</p>
                                                <p className="service-labels-sub"
                                                    style={{
                                                        color: (receiverData.ticket_status_ysn === 0 || receiverData.ticket_status_ysn === 1 || receiverData.ticket_status_ysn === 5) ? "blue" :
                                                            receiverData.ticket_status_ysn === 2 ? "rgb(10, 201, 71)" :
                                                                (receiverData.ticket_status_ysn === 6 || receiverData.ticket_status_ysn === 7) ? "red" : '',
                                                        fontWeight: '700'
                                                    }}
                                                >
                                                    {receiverData.ticket_status_ysn === 0 && "Closed"}
                                                    {receiverData.ticket_status_ysn === 1 && "Open"}
                                                    {receiverData.ticket_status_ysn === 2 && "In-Progress"}
                                                    {receiverData.ticket_status_ysn === 5 && "Re-open"}
                                                    {receiverData.ticket_status_ysn === 6 && "Incomplete"}
                                                    {receiverData.ticket_status_ysn === 7 && "Cancelled"}
                                                </p>
                                            </div>

                                            {proDiagnosis ?
                                                <div
                                                    className='row'
                                                >
                                                    <div
                                                        className='col-12 px-3 py-2 d-flex  flex-column'
                                                    >
                                                        <div className='pb-2 d-flex align-items-center justify-content-between'>
                                                            <span className='font-w600 text-black fs-5'>
                                                                {<>{`Comments`}</>}
                                                            </span>

                                                        </div>

                                                        <div
                                                            className=' p-2 px-3'
                                                            style={{
                                                                border: toggleEditProDiagnosis ? 'none' : '1px solid rgb(0 0 0 / 26%)',
                                                                borderRadius: '8px',
                                                                backgroundColor: toggleEditProDiagnosis ? 'white' : 'rgba(245, 247, 251, 1)'
                                                            }}
                                                        >

                                                            <span>
                                                                {proDiagnosis ?
                                                                    proDiagnosis :
                                                                    `-`}
                                                            </span>

                                                        </div>
                                                    </div>
                                                </div> :
                                                <>
                                                    <div className='px-3 py-2'>
                                                        <span className='font-w600 text-black fs-5'>
                                                            {`No estimation available at the moment.`}
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {proDiagnosis &&
                                                <div
                                                    className='row'
                                                >
                                                    <div
                                                        className='col-12 px-3 pb-2 d-flex  flex-column'
                                                    >
                                                        <div className='pb-2'><span className='font-w600 text-black fs-5'>Estimated Cost</span></div>

                                                        <div
                                                            className='p-2 px-3'
                                                            style={{
                                                                border: '1px solid rgb(0 0 0 / 26%)',
                                                                borderRadius: '8px',
                                                                backgroundColor: 'rgba(245, 247, 251, 1)'
                                                            }}
                                                        >
                                                            <div className='pb-3'><span> {`Our diagnosis puts the cost range between`}</span></div>

                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <div
                                                                    className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                    style={{
                                                                        border: '1px solid orange',
                                                                        borderRadius: '4px',
                                                                        width: '45%',
                                                                    }}
                                                                >
                                                                    <span className='font-w600 text-black'>
                                                                        {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min ?
                                                                            USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_min.toFixed(2))) :
                                                                            `-`}
                                                                    </span>
                                                                </div>

                                                                <div
                                                                    className='p-2 d-flex align-items-center justify-content-center'
                                                                >
                                                                    <span> {`and`}</span>
                                                                </div>

                                                                <div
                                                                    className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                    style={{
                                                                        border: '1px solid orange',
                                                                        borderRadius: '4px',
                                                                        width: '45%',
                                                                    }}
                                                                >
                                                                    <span className='font-w600 text-black'>

                                                                        {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max ?
                                                                            USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_max.toFixed(2))) :
                                                                            `-`}
                                                                    </span>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {/* Pro Recommendation */}
                                            {proRecommendedSolution ?
                                                <div
                                                    className='row'
                                                >
                                                    <div
                                                        className='col-12 px-3 pb-2 d-flex  flex-column'
                                                    >
                                                        <div className='pb-2'><span className='font-w600 text-black fs-5'>Pro Recommendation</span></div>

                                                        <div className='d-flex align-items-center'>
                                                            <div
                                                                className='p-2 px-3 me-3 d-flex align-items-center justify-content-center'
                                                                style={{
                                                                    border: '1px solid rgb(0 0 0 / 26%)',
                                                                    borderRadius: '8px',
                                                                    backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                    width: '90px',
                                                                    height: '75px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        proRecommendedSolution == 1 ?
                                                                            NewDIYSoloImg :
                                                                            proRecommendedSolution == 2 ?
                                                                                NewDIYRemoteProImg :
                                                                                proRecommendedSolution == 3 ?
                                                                                    NewLocalProImg :
                                                                                    NewLocalProImg
                                                                    }
                                                                    alt="Error"
                                                                    style={{ width: '35px', height: '35px', }}
                                                                />
                                                            </div>

                                                            <div className='d-flex flex-column text-black'>
                                                                <span className='font-w600 pb-1'>
                                                                    {`${proRecommendedSolution == 1 ? 'DIY (Solo)' : proRecommendedSolution == 2 ? 'DIY + Remote Pro' : proRecommendedSolution == 3 ? 'Local Pro' : 'Local Pro'}`}
                                                                </span>
                                                                <span className='font-w500'>
                                                                    {
                                                                        `
                                                                                                                                                    ${proRecommendedSolution == 1 ? 'Use the Chilll Tech Tool Box to manage your project.' :
                                                                            proRecommendedSolution == 2 ? 'Connect with a remote pro & get expert guidance.' :
                                                                                proRecommendedSolution == 3 ? 'Get a qualified Pro to your house on your terms.' : ''}`
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>



                                                    </div>
                                                </div> :
                                                null
                                            }



                                            {false &&
                                                <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                    <div className='col-4 py-2'>
                                                        <span>{`Call recordings`}</span>
                                                    </div>
                                                    <div className='col-8'>
                                                        <div className='row mx-0'>
                                                            <div className=' px-0 py-2'>

                                                                {getCallRecordingsLoading ?
                                                                    <>
                                                                        <div className=''>
                                                                            <div className='mb-3'>
                                                                                <SkeletonDivElement height={'20px'} width={'150px'} borderRadius={'0px'} />
                                                                            </div>

                                                                            <div className='d-flex'>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                            </div>



                                                                        </div>
                                                                    </> :
                                                                    <>
                                                                        {callRecordingsArr?.length > 0 ?
                                                                            <>
                                                                                {callRecordingsArr?.map((ele, index) => {
                                                                                    let professionalName = '';
                                                                                    let customerName = '';
                                                                                    let professionalsCallRecordingsArr = [];
                                                                                    let customersCallRecordingsArr = [];
                                                                                    ele?.recordings?.map(ele => {
                                                                                        // if (ele?.user_details?.role_display_name_chr === "Professional") {
                                                                                        //     professionalName = ele?.user_details?.first_name_chr;
                                                                                        //     professionalsCallRecordingsArr.push(ele);
                                                                                        // } else {
                                                                                        //     if (ele.user_details.user_id_ids) {
                                                                                        //         customerName = ele?.user_details?.first_name_chr;
                                                                                        //     } else {
                                                                                        //         customerName = `${ele?.user_details?.first_name_chr} (Guest customer)`;
                                                                                        //     }
                                                                                        //     customersCallRecordingsArr.push(ele);
                                                                                        // }

                                                                                        if (
                                                                                            ele?.user_details?.roles?.some(
                                                                                                role => role.role_display_name_chr === "Professional"
                                                                                            )
                                                                                        ) {
                                                                                            professionalName = ele?.user_details?.first_name_chr;
                                                                                            professionalsCallRecordingsArr.push(ele);
                                                                                        } else {
                                                                                            if (ele?.user_details?.user_id_ids) {
                                                                                                customerName = `${ele?.user_details?.first_name_chr} (Customer)`;
                                                                                            } else {
                                                                                                customerName = `${ele?.user_details?.first_name_chr} (Guest customer)`;
                                                                                            }
                                                                                            customersCallRecordingsArr.push(ele);
                                                                                        }
                                                                                    });

                                                                                    // console.log(professionalsCallRecordingsArr, 'professionalsCallRecordingsArr');
                                                                                    // console.log(customersCallRecordingsArr, 'customersCallRecordingsArr');
                                                                                    return (
                                                                                        <div className={`${callRecordingsArr?.length > 1 ? 'border-bottom' : ''} `} key={index}>
                                                                                            {ele?.recordings?.length > 0 &&
                                                                                                <div className={`d-flex align-items-center mb-2 ${callRecordingsArr?.length > 1 ? 'pt-2' : ''}`}>
                                                                                                    <span className='me-3'>Call date and time : <strong className='text-black'>{`${ele?.created_date_dtm ? formatUnixTimestamp(ele?.created_date_dtm) : '-'}`}</strong></span>
                                                                                                    {/* <span>Call duration : <strong className='text-black'>{formatTime(ele?.call_duration_in_second)}</strong></span> */}
                                                                                                </div>
                                                                                            }


                                                                                            {ele?.recordings?.length > 0 ?
                                                                                                <div className='row mx-0'>
                                                                                                    <div className='col-12'>
                                                                                                        <span className='text-black font-w600'>{`${professionalName} (Professional)`}</span>
                                                                                                    </div>

                                                                                                    <div className='col-12'>
                                                                                                        {professionalsCallRecordingsArr?.length > 0 ?
                                                                                                            <>
                                                                                                                <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                    {professionalsCallRecordingsArr?.map((item, index) => {
                                                                                                                        return (
                                                                                                                            <div className="me-1" key={index}>
                                                                                                                                <div className="tooltipCustom">
                                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                    <span
                                                                                                                                        className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                        style={{ height: '45px', width: '45px' }}
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            handleOpenVideoAudio();
                                                                                                                                            setVideoAudioURL(item?.media_location);
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {item?.type === "audio" ?
                                                                                                                                            <i className="bi bi-mic text-success"></i> :
                                                                                                                                            <i className="bi bi-camera-video-fill text-success"></i>
                                                                                                                                        }
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        )
                                                                                                                    })}
                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <>
                                                                                                                <span>{`No sessions are recorded`}</span>
                                                                                                            </>
                                                                                                        }

                                                                                                    </div>




                                                                                                    <div className='col-12 d-flex'>
                                                                                                        <span className='text-black font-w600'>{customerName}</span>
                                                                                                    </div>

                                                                                                    <div className='col-12 d-flex'>
                                                                                                        {customersCallRecordingsArr?.length > 0 ?
                                                                                                            <>
                                                                                                                <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                    {customersCallRecordingsArr?.map((item, index) => {
                                                                                                                        return (
                                                                                                                            <div className="me-1" key={index}>
                                                                                                                                <div className="tooltipCustom">
                                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                    <span
                                                                                                                                        className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                        style={{ height: '45px', width: '45px' }}
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            handleOpenVideoAudio();
                                                                                                                                            setVideoAudioURL(item?.media_location);
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {item?.type === "audio" ?
                                                                                                                                            <i className="bi bi-mic text-success"></i> :
                                                                                                                                            <i className="bi bi-camera-video-fill text-success"></i>
                                                                                                                                        }
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        )
                                                                                                                    })}
                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <>
                                                                                                                <span>{`No sessions are recorded`}</span>
                                                                                                            </>
                                                                                                        }
                                                                                                    </div>
                                                                                                </div> :
                                                                                                <>
                                                                                                    <span>{`No sessions are recorded`}</span>
                                                                                                </>
                                                                                            }

                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </> :
                                                                            <>
                                                                                <span className=''>{`No sessions are recorded`}</span>
                                                                            </>
                                                                        }
                                                                    </>
                                                                }


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {/* Composed Recordings */}
                                            {
                                                <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                    <div className='col-4 py-2'>
                                                        <span>{`Composed recordings`}</span>
                                                    </div>
                                                    <div className='col-8'>
                                                        <div className='row mx-0'>
                                                            <div className=' px-0 py-2'>

                                                                {getComposeRecordingsLoading ?
                                                                    <>
                                                                        <div className=''>
                                                                            <div className='mb-3'>
                                                                                <SkeletonDivElement height={'20px'} width={'150px'} borderRadius={'0px'} />
                                                                            </div>

                                                                            <div className='d-flex'>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                                <span className='pe-2'>
                                                                                    <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                </span>
                                                                            </div>



                                                                        </div>
                                                                    </> :
                                                                    <>
                                                                        {composeRecordingsArr?.length > 0 ?
                                                                            <>
                                                                                {composeRecordingsArr?.map((ele, index) => {
                                                                                    return (
                                                                                        <div className={`${composeRecordingsArr?.length > 1 ? 'border-bottom' : ''} `} key={index}>
                                                                                            {
                                                                                                <div className={`d-flex align-items-center mb-2 ${composeRecordingsArr?.length > 1 ? 'pt-2' : ''}`}>
                                                                                                    <span className='me-3'>Call date and time : <strong className='text-black'>{`${ele?.created_date_dtm ? formatUnixTimestamp(ele?.created_date_dtm) : '-'}`}</strong></span>
                                                                                                    {/* <span>Call duration : <strong className='text-black'>{formatTime(ele?.call_duration_in_second)}</strong></span> */}
                                                                                                </div>
                                                                                            }

                                                                                            <div className='row mx-0'>

                                                                                                <div className='col-12'>
                                                                                                    {ele?.composed_recording?.length > 0 ?
                                                                                                        <>
                                                                                                            <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                {ele?.composed_recording?.map((item, index) => {
                                                                                                                    return (
                                                                                                                        <div className="me-1" key={index}>
                                                                                                                            {item?.status === "completed" ?
                                                                                                                                <div className="tooltipCustom">
                                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                    <span
                                                                                                                                        className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                        style={{ height: '45px', width: '45px' }}
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            handleOpenVideoAudio();
                                                                                                                                            setVideoAudioURL(item?.media_location);
                                                                                                                                        }}
                                                                                                                                    >

                                                                                                                                        <i className="bi bi-camera-video-fill text-success"></i>

                                                                                                                                    </span>
                                                                                                                                </div> :
                                                                                                                                (item?.status === "enqueued" || item?.status === "processing") ?
                                                                                                                                    <span>{`Composition is in progress, please try after some time.`}</span> :
                                                                                                                                    item?.status === "failed" ?
                                                                                                                                        <span>{`Composition of this session is failed`}</span> : ''
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                })}
                                                                                                            </div>
                                                                                                        </> :
                                                                                                        <>
                                                                                                            <span>{`For this call no recording is available`}</span>
                                                                                                        </>
                                                                                                    }

                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </> :
                                                                            <>
                                                                                <span className=''>{`For this call no recording is available`}</span>
                                                                            </>
                                                                        }
                                                                    </>
                                                                }


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }





                                            {/* Attachment will come here */}

                                            {attachmentsArr?.length > 0 &&
                                                <div className='d-flex photos-section'>
                                                    {/* <div className='photos-section-title'>{txtPhotos}</div> */}
                                                    <div className='photos-section-title'>{`Attachments`}</div>
                                                    <div className='attached-img-container' >
                                                        {attachmentsArr.map((element, key) => {
                                                            return (
                                                                <>
                                                                    <div key={key}
                                                                        className='attached-img-individual-box'
                                                                        onClick={() => { handleOpenDoc(); setImageAttach(key) }}
                                                                    >
                                                                        <img src={element.url} alt="Error Loading" className='serviceImg' />
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            }

                                        </>
                                    </>}
                            </div>
                        </>
                    }
                    {toggleNotesPurchase === 2 &&
                        <>
                            <div style={{ margin: '15px' }}>
                                {/* <div className='callDetailsRows'>
                                    <p className='call-titles' >{txtName}</p>
                                    {receiverData?.map((element, index) => (
                                    <p className='call-sub-titles'>{element?.name ? element?.name.split(' ')[0] : 'NA'}</p>
                                ))}
                                </div> */}

                                {isCallList.length > 0 ? <div>
                                    <div className='callDetailsRows'>
                                        <p className='call-titles'>{txtCreatedOn}</p>
                                        <p className='call-sub-titles'>
                                            {new Intl.DateTimeFormat("en-US", {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                            }).format(timeCallNote)}
                                        </p>
                                    </div>

                                    <div className='callDetailsRows'>
                                        <p className='call-titles'>{txtMessage}</p>
                                        <p className='call-sub-titles'>{callDetailsObj?.message_chr ? callDetailsObj?.message_chr : 'NA'}</p>
                                    </div>
                                    {/* <div className='callDetailsRows'>
                                    <p className='call-titles'>Rating</p>
                                    <ReadOnlyRating rating={showUserRating > 0 ? showUserRating : 0} />
                                </div> */}

                                    {callNoteDetailsArr.length > 0 &&
                                        <div className='call-notes-main-container'
                                        // style={{ height: callNoteDetailsArr.length <= 1 ? '215px' : '280px', }}
                                        >
                                            <p className='call-notes-titles'>Call notes : </p>
                                            <div className='call-notes-overflow-container'>
                                                {callNoteDetailsArr.map((element, index) => (
                                                    <div className='call-notes-sub-container'>
                                                        <p className='call-notes-user-msg' >
                                                            <span className='call-notes-user-icon' >
                                                                {element.created_by_name?.substring(0, 1).toUpperCase()}
                                                            </span>
                                                            {element.note_chr}
                                                        </p>

                                                        <div className='call-notes-individual-img-attached-box'>
                                                            <span className='d-flex align-items-center' style={{ justifyContent: 'flex-end', color: 'black' }}>
                                                                {new Intl.DateTimeFormat("en-US", {
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    second: "2-digit",
                                                                }).format(element?.updated_date_dtm + "000")}
                                                            </span>
                                                            <div className='call-notes-individual-img-download-box' >
                                                                {element?.attachment_url?.map((elem, ind) => {
                                                                    return (

                                                                        <span className='call-notes-individual-img-download-span' key={index}>
                                                                            {/* <a
                                        href={elem?.note_attachments_url_chr}
                                        download
                                    > */}
                                                                            <img
                                                                                className='call-notes-individual-img-download'
                                                                                src={elem}
                                                                                alt='Error'
                                                                                title='Download'
                                                                                onClick={() => {
                                                                                    handleOpenDocCall();
                                                                                    setImageAttachURL(elem);
                                                                                }}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                            {/* </a> */}
                                                                        </span>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                </div> :
                                    <div style={{ fontSize: '16px', textAlign: 'center', margin: '15px 0px', fontWeight: '600', height: '45vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        No data found
                                    </div>
                                }
                            </div>
                        </>
                    }

                    {toggleNotesPurchase === 3 &&
                        <>
                            <div style={{ margin: '15px' }}>
                                {rows.length > 0 &&
                                    <div className='purchase-list-total-cost'>
                                        <p style={{ marginBottom: '0px' }}><span style={{ fontWeight: '600' }}>Items:</span> {rows.length}</p>
                                        {totalCost && <p style={{ marginBottom: '0px' }}><span style={{ fontWeight: '600' }}>Total Cost:</span> {USDollar.format(parseFloat(totalCost.toFixed(2)))}</p>}
                                    </div>}
                                {rows.length > 0 ?
                                    <div className='purchase-item-main-container'>
                                        {
                                            rows.map((element, index) => {
                                                return (
                                                    <div className='individual-purchase-item-container' key={index}>

                                                        <div style={{ display: 'flex', }}>
                                                            <div className='purchase-list-numbering' style={{ width: '10%' }}>
                                                                <p style={{ marginBottom: '5px' }}>{index + 1}.</p>
                                                            </div>
                                                            <div style={{ width: '90%', color: 'black', fontSize: '14px' }}>
                                                                <p style={{ marginBottom: '0px', fontWeight: '600', fontSize: '16px' }}><strong>{element.item_name_chr ? element.item_name_chr : 'NA'}</strong></p>
                                                                {(element.quantity_int || element.estimated_price_float) && <p style={{ marginBottom: '0px' }}>({element?.quantity_int}) X {USDollar.format((element?.estimated_price_float) / (element?.quantity_int))} = {USDollar.format(element?.estimated_price_float)}</p>}

                                                                {/* {element?.purchase_link_chr && <div style={{ display: 'flex', }}>
                                                                    <>
                                                                        <a href={element?.purchase_link_chr} target="_blank" rel="noreferrer">
                                                                            <p className='call-sub-titles purchase-item-link' style={{ marginBottom: '5px', overflow: 'hidden', color: 'blue', wordBreak: "break-all", fontWeight: '500' }}>
                                                                                {element?.purchase_link_chr}
                                                                            </p>
                                                                        </a>

                                                                        <OverlayTrigger placement="top" overlay={tooltipCopyTxt}>
                                                                            <div
                                                                                onClick={() => {
                                                                                    navigator.clipboard.writeText(`${element?.purchase_link_chr}`);
                                                                                    copyToClipboard();
                                                                                }}
                                                                                className="d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    color: "#0AC947",
                                                                                    fontSize: "14px",
                                                                                    cursor: "pointer",
                                                                                    marginLeft: '10px'
                                                                                }}>
                                                                                <i className="bi bi-files"></i>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </>
                                                                </div>
                                                                } */}

                                                                {element?.purchase_link_chr != "" && (
                                                                    <div className="row mx-0  mt-2">
                                                                        <div className="col-12 d-flex justify-content-start align-items-center">
                                                                            {urlPattern.test(element?.purchase_link_chr) ?
                                                                                <>
                                                                                    <div className="d-flex align-items-center">

                                                                                        <span className="text-black font-w500 me-2">{`Website: `}</span>
                                                                                        <a
                                                                                            className="text-black font-w500 text-hovered"
                                                                                            href={
                                                                                                // element?.purchase_link_chr
                                                                                                element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                                                                    ? `https://${element?.purchase_link_chr}`
                                                                                                    : element?.purchase_link_chr
                                                                                            }
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                            }}
                                                                                        >
                                                                                            <span
                                                                                                className="pointer cursor-pointer text-truncate d-flex purchase-item-link"
                                                                                                style={{ maxWidth: '200px', color: 'blue', wordBreak: "break-all", fontWeight: '500' }}
                                                                                            // onClick={() => {
                                                                                            //   navigator.clipboard.writeText(
                                                                                            //     `${element?.purchase_link_chr}`
                                                                                            //   );
                                                                                            //   copyToClipboard();
                                                                                            // }}
                                                                                            >
                                                                                                {`${element?.purchase_link_chr}`}
                                                                                                {/* <FaArrowRightLong />{" "} */}
                                                                                            </span>
                                                                                        </a>
                                                                                        <span >{`...`}</span>
                                                                                    </div>
                                                                                </> :
                                                                                <div>
                                                                                    <span className="font-w500 me-2">{`Location: `}</span>
                                                                                    <span
                                                                                        className=""
                                                                                    >
                                                                                        {element?.purchase_link_chr}
                                                                                    </span>
                                                                                </div>
                                                                            }

                                                                            <OverlayTrigger placement="top" overlay={tooltipCopyTxt}>
                                                                                <div
                                                                                    onClick={() => {
                                                                                        navigator.clipboard.writeText(`${element?.purchase_link_chr}`);
                                                                                        copyToClipboard();
                                                                                    }}
                                                                                    className="d-flex align-items-center justify-content-center"
                                                                                    style={{
                                                                                        color: "#0AC947",
                                                                                        fontSize: "14px",
                                                                                        cursor: "pointer",
                                                                                        marginLeft: '10px'
                                                                                    }}>
                                                                                    <i className="bi bi-files"></i>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                            {
                                                                (new Date(element?.updated_date_dtm * 1000)).toLocaleString('en-US', {
                                                                    month: 'long',
                                                                    day: 'numeric',
                                                                    year: 'numeric',
                                                                    hour: 'numeric',
                                                                    minute: '2-digit',
                                                                    hour12: true
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> :

                                    <div style={{ fontSize: '16px', textAlign: 'center', margin: '15px 0px', fontWeight: '600', height: '45vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        No data found
                                    </div>
                                }
                            </div>
                        </>
                    }
                </div>
            </div>








            {/* Modal for previewing the attached image preview */}
            <>

                <Modal show={openDoc} onHide={handleCloseDoc} style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={attachmentsArr[imageAttach]?.url} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>


                    <>
                        <img src={attachmentsArr[imageAttach]?.url} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {/* Modal for previewing the attached image preview call notes*/}
            <>

                <Modal show={openDocCall} onHide={handleCloseDocCall} style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDocCall} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

            {(openVideoAudio) && <VideoAudioPlayer videoAudioURL={videoAudioURL} handleCloseVideoAudio={handleCloseVideoAudio} />}

        </>
    );

}
